import Vue from 'vue';
import Vuex from 'vuex';

import snackbarModule from './modules/snackbar';
import brandModule from './modules/brands';
import regionModule from './modules/regions';
import languageModule from './modules/languages';
import productAreaRangeModule from './modules/productAreaRange';
import documentModule from './modules/documents';
import documentTypesModule from './modules/documentTypes';
import userModule from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    snackbar: snackbarModule,
    brands: brandModule,
    regions: regionModule,
    languages: languageModule,
    products: productAreaRangeModule,
    documents: documentModule,
    documentTypes: documentTypesModule,
    user: userModule
  },
  state: {
    showResults: false,
    isIE: false
  },
  mutations: {
    toggleResults(state) {
      state.showResults = !state.showResults;
    }
  }
});
